export default __webpack_public_path__ + "static/media/box.cb7efe20.svg";